import React, { useEffect } from "react";
import rCoin from "../../assets/images/shell.png";
import { useDispatch, useSelector } from "react-redux";
import male from "../../assets/images/male.png";
import { getUser } from "../../store/user/action";
import { useNavigate } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";
import { T, glassCard } from "../../util/theme";

export const CreatorDetails = () => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const agencyId = localStorage.getItem("agencyId");

  useEffect(() => {
    dispatch(getUser(agencyId));
  }, [dispatch, agencyId]);

  const handleOpenHostHistory = (id) => {
    navigate("/agencypanel/hosthistory", { state: { id } });
  };

  return (
    <div style={{ padding: "4px 16px 8px", maxWidth: 480, margin: "0 auto" }}>
      {user?.map((data) => (
        <div
          key={data?._id}
          style={{
            ...glassCard,
            padding: "14px 14px",
            marginBottom: 12,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <img
              src={data?.image ? data?.image : male}
              style={{
                height: 46,
                width: 46,
                objectFit: "cover",
                borderRadius: "50%",
                flexShrink: 0,
              }}
              alt=""
            />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <p
                  style={{
                    margin: 0,
                    fontWeight: 800,
                    fontSize: 14,
                    color: "#fff",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {data?.name ? data?.name : "-"}
                </p>
                <span
                  style={{
                    background: T.gradPinkPurple,
                    color: "#fff",
                    fontSize: 10,
                    borderRadius: 6,
                    padding: "2px 8px",
                    fontWeight: 500,
                    flexShrink: 0,
                  }}
                >
                  {t("Host")}
                </span>
              </div>
              <p
                style={{
                  margin: "0",
                  fontSize: 12,
                  color: T.sub,
                  fontWeight: 400,
                }}
              >
                {t("ID")}: {data?.uniqueId ? data?.uniqueId : "-"}
              </p>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 14,
              gap: 10,
            }}
          >
            <div
              style={{
                color: "#fff",
                fontWeight: 600,
                fontSize: 16,
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              {t("host_income")}:
              <img src={rCoin} alt="" height={18} width={20} />
              <span style={{ fontWeight: 700 }}>
                {data?.currentCoin ? data?.currentCoin : 0}
              </span>
            </div>

            <button
              type="button"
              className="agency-grad-btn"
              style={{
                padding: "8px 18px",
                fontSize: 12,
                fontWeight: 600,
                borderRadius: 10,
                whiteSpace: "nowrap",
              }}
              onClick={() => handleOpenHostHistory(data?._id)}
            >
              {t("history")} &gt;&gt;
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
